import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=9f28f096&scoped=true"
import script from "./Trend.vue?vue&type=script&lang=js"
export * from "./Trend.vue?vue&type=script&lang=js"
import style0 from "./Trend.vue?vue&type=style&index=0&id=9f28f096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f28f096",
  null
  
)

export default component.exports